import React from 'react';
import HeaderSection from "../headerSection/HeaderSection";

export default function Vow() {
    return (
        <div>
            <HeaderSection></HeaderSection>
            <p>نذورات</p>
        </div>
    )
}
